import $ from 'jquery';
import slick from 'slick-carousel';

/** ----------------------------------------
    Map Filter
 ---------------------------------------- */

export class Sliders {

    // ---------------------------------
    // Constructor
    // ---------------------------------

    constructor() {
        $(document).ready(() => {
            this.sliders = $('.slider');

            this._init();
        });
    }

    _handleSlider(sliderNode) {
        const slideN = parseFloat($(sliderNode).attr('slideN'));
        const slideContainer = $(sliderNode).find('.slider__slides');
        const leftArrow = $(sliderNode).find('.slider__arrows').find('.slider__arrows--left');
        const rightArrow = $(sliderNode).find('.slider__arrows').find('.slider__arrows--right');
        const calendar = $(sliderNode).hasClass('calendar');

        slideContainer.slick({
            infinite: false,
            slidesToShow: slideN,
            arrows: true,
            slidesToScroll: 1,
            prevArrow: leftArrow,
            nextArrow: rightArrow,
            adaptiveHeight: calendar,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: Math.round(slideN / 2),
                    }
                },
                {
                    breakpoint: 560,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

    // ---------------------------------
    // Init
    // ---------------------------------

    _init() {
        this.sliders.each((index, sliderNode) => {
            if (sliderNode.dataset.sliderInitialized) 
                return;
            
            sliderNode.dataset.sliderInitialized = true;

            this._handleSlider(sliderNode);
        });
    }
}